export const isDevelopment = import.meta.env.DEV;
